module.exports = __webpack_public_path__ + "static/media/IMG_4274.e9a0eb00.PNG";